import styled from 'styled-components';
import { shape, string, bool } from 'prop-types';
import { C_SHADOW, C_LUNAR } from '@bbc/psammead-styles/colours';
import { GEL_SPACING_TRPL } from '@bbc/gel-foundations/spacings';
import { getBodyCopy } from '@bbc/gel-foundations/typography';
import { scriptPropType } from '@bbc/gel-foundations/prop-types';
import { getSansRegular } from '@bbc/psammead-styles/font-styles';
var Paragraph = /*#__PURE__*/styled.p.withConfig({
  displayName: "Paragraph",
  componentId: "k859h4-0"
})(["", ";", " color:", ";padding-bottom:", ";margin:0;"], function (_ref) {
  var script = _ref.script;
  return script && getBodyCopy(script);
}, function (_ref2) {
  var service = _ref2.service;
  return getSansRegular(service);
}, function (_ref3) {
  var darkMode = _ref3.darkMode;
  return darkMode ? C_LUNAR : C_SHADOW;
}, GEL_SPACING_TRPL);
Paragraph.propTypes = {
  script: shape(scriptPropType).isRequired,
  service: string.isRequired,
  darkMode: bool
};
Paragraph.defaultProps = {
  darkMode: false
};
export default Paragraph;